import { useQuery } from "@tanstack/react-query";
import type { Category } from "@arc/contracts";
import type { AuthSession } from "../../auth/keycloak.js";
import { categoryApi } from "../../api/client.js";

/**
 * A single facility's ATTACHED categories (`GET /facilities/:id/categories`, server-sorted by name). Keyed by
 * facility id so attach/detach can invalidate exactly this facility. `enabled` lets callers defer the fetch until the
 * manage drawer is open (no request while merely browsing).
 */
export function useFacilityCategories(session: AuthSession | null, facilityId: number | null, enabled = true) {
  return useQuery({
    queryKey: ["facility-categories", session?.realm, session?.sub, facilityId],
    enabled: session !== null && facilityId !== null && enabled,
    queryFn: async (): Promise<Category[]> => {
      const res = await categoryApi.getFacilityCategories({ params: { id: facilityId! } });
      if (res.status !== 200) throw new Error(`GET /facilities/${facilityId!}/categories returned ${res.status}`);
      return res.body.categories;
    },
  });
}
